var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSinoNotificacao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.948,
    height: 23.974,
    viewBox: "0 0 26.948 23.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4106",
    "data-name": "Grupo 4106",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1836",
    "data-name": "Caminho 1836",
    d: "M8.529.916a.444.444,0,0,1,.078,0,.819.819,0,0,1,.719.827v.3a5.143,5.143,0,0,1,4.349,5.077c0,8.624,2.459,5.514,2.459,7.791v.121a.427.427,0,0,1-.426.426H1.35a.427.427,0,0,1-.426-.426c0-2.636,2.459.937,2.459-7.912A5.143,5.143,0,0,1,7.732,2.052V1.713a.8.8,0,0,1,.8-.8m2.663,15.348a2.669,2.669,0,0,1-5.327,0H11.19M8.529,0A1.714,1.714,0,0,0,6.866,1.305a6.019,6.019,0,0,0-4.4,5.824c0,5.164-.818,5.583-1.257,5.808a2,2,0,0,0-1.2,2.107,1.344,1.344,0,0,0,1.342,1.342H4.959a3.584,3.584,0,0,0,7.145,0H15.71a1.344,1.344,0,0,0,1.342-1.342v-.121a1.912,1.912,0,0,0-1.14-1.933c-.46-.247-1.319-.71-1.319-5.858a6.02,6.02,0,0,0-4.406-5.826A1.735,1.735,0,0,0,8.7.011Q8.614,0,8.531,0h0Z",
    transform: "translate(-0.011 4.291)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4132",
    "data-name": "Grupo 4132",
    transform: "translate(10.691 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinoNotificacao);
export default __webpack_public_path__ + "static/media/sinoNotificacao.f730041392e91f6b90cf44e79d186341.svg";
export { ForwardRef as ReactComponent };